var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Icon',{attrs:{"label":_vm.label,"allowClickOnMobile":_vm.allowClickOnMobile},scopedSlots:_vm._u([{key:"default",fn:function({ on }){return [(_vm.icon)?_c('img',_vm._g({staticClass:"rarity-icon",attrs:{"src":_vm.rarity,"width":_vm.width,"draggable":"false"}},on)):_vm._e()]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }